import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import servicesData from "../data/services.json";
import Enquiry from "../components/sections/Enquiry";
import { PiCertificate, PiBriefcaseLight, PiChalkboardTeacher, PiHandshakeLight } from "react-icons/pi";
import { FaLaptopCode, FaChartLine } from "react-icons/fa";

export default function InternshipDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const internship = servicesData.internships.find((i) => i.slug === slug);

  if (!internship) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Internship not found
          </h2>
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 hover:text-gray-900 font-medium"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-white border-b border-gray-100 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 
                       font-medium transition-colors group"
          >
            <svg
              className="w-5 h-5 group-hover:-translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to Internships
          </button>
        </div>
      </div>

      <section className="bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <div className="text-gray-500 text-sm mb-6 flex items-center gap-2 font-medium">
                <span className="hover:text-gray-700 cursor-pointer">
                  Internships
                </span>
                <span>/</span>
                <span className="text-gray-700">{internship.title}</span>
              </div>

              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight text-gray-900">
                {internship.title}
              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                {internship.desc}
              </p>

              <div className="flex flex-wrap gap-8 mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center">
                    <span className="text-xl"><PiBriefcaseLight /></span>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 font-medium">Type</p>
                    <p className="text-lg font-semibold text-gray-900">
                      Internship Program
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center">
                    <span className="text-xl"><FaLaptopCode /></span>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 font-medium">
                      Experience
                    </p>
                    <p className="text-lg font-semibold text-gray-900">
                      Hands-on Learning
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center">
                    <span className="text-xl"><PiCertificate /></span>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 font-medium">
                      Certificate
                    </p>
                    <p className="text-lg font-semibold text-gray-900">
                      Included
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <button
                  onClick={() => {
                    const el = document.getElementById("enquiry");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="w-full bg-gray-900 text-white py-4 rounded-lg 
             font-semibold text-base hover:bg-gray-800 
             transition-all shadow-md hover:shadow-lg"
                >
                  Enroll Now
                </button>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="sticky top-24">
                <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
                  <img
                    src={internship.img}
                    alt={internship.title}
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2 space-y-16">
            <section>
              <h2 className="text-3xl font-bold mb-8 text-gray-900">
                What you'll gain from this internship
              </h2>

              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
                <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
                  {internship.gain.map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <svg
                        className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2.5}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <p className="text-gray-700 font-medium leading-relaxed">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>
            <section id="enquiry">
              <Enquiry enquiryType={`Internship - ${internship.title}`} />
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-8 text-gray-900">
                About this internship
              </h2>

              <div className="prose prose-lg max-w-none">
                <p className="text-gray-700 leading-relaxed text-lg whitespace-pre-line">
                  {internship.about}
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-3xl font-bold mb-8 text-gray-900">
                Program Features
              </h2>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><FaLaptopCode /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Practical Training
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Work on real-world projects and gain hands-on experience
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><PiChalkboardTeacher /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Expert Mentorship
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Learn from experienced industry professionals
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><PiCertificate /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Certification
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Receive a certificate upon successful completion
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><PiBriefcaseLight /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Portfolio Building
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Create impressive projects for your portfolio
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><PiHandshakeLight /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Collaborative Work
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Experience team collaboration and agile workflows
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all">
                  <div className="w-14 h-14 bg-indigo-50 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-3xl"><FaChartLine /></span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">
                    Career Growth
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Build skills and connections for your career
                  </p>
                </div>
              </div>
            </section>
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24 space-y-6">
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
                <h3 className="font-bold text-gray-900 mb-6 text-lg">
                  This program includes:
                </h3>

                <ul className="space-y-4">
                  {internship.includes.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-3 text-gray-700"
                    >
                      <svg
                        className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-sm font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 shadow-sm">
                <button
                  onClick={() => {
                    const el = document.getElementById("enquiry");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="w-full bg-gray-900 text-white px-8 py-4 rounded-lg 
             font-semibold text-base hover:bg-gray-800 
             transition-all shadow-lg hover:shadow-xl"
                >
                  Enroll Now
                </button>

                <p className="text-gray-500 text-xs text-center mt-4">
                  Start your professional journey with us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
